export default {"src":"/_next/static/media/logoWithName.1cfe0e22.svg","height":36,"width":200,"blurWidth":0,"blurHeight":0};